// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMEmptyState.tsx — PropelMapper empty / zero-data state.
//
// The centered "nothing here yet" block: an icon disc, a title, a short
// description, and optional actions. Use for first-run (no data), no-results
// (after a search/filter), and recoverable errors. Presentational.
//
// System rules: neutral disc by default (--pm-surface-variant + fg-3); brand tone
// uses the Mint primary-surface + Pine glyph; plain declarative voice; actions are
// real PMButtons passed in. Text column is width-capped for readability.
//
//   <PMEmptyState icon={<PMIcon name="search" size={26}/>}
//     title="No locations match" description="Try clearing a filter or widening the date range."
//     action={<PMButton variant="ghost">Clear filters</PMButton>} />

const PMEMPTY_CSS = `
.pmempty{display:flex;flex-direction:column;gap:6px;font-family:var(--pm-font-sans);box-sizing:border-box}
.pmempty--center{align-items:center;text-align:center;margin:0 auto}
.pmempty--start{align-items:flex-start;text-align:left}
.pmempty--sm{padding:24px 20px}
.pmempty--md{padding:44px 24px}
.pmempty--lg{padding:64px 24px}
.pmempty-ico{display:grid;place-items:center;border-radius:50%;background:var(--pm-surface-variant);color:var(--pm-fg-3);margin-bottom:10px}
.pmempty--brand .pmempty-ico{background:var(--pm-primary-surface);color:var(--pm-primary)}
.pmempty--sm .pmempty-ico{width:44px;height:44px}
.pmempty--md .pmempty-ico{width:56px;height:56px}
.pmempty--lg .pmempty-ico{width:68px;height:68px}
.pmempty-title{font:600 16px/1.3 var(--pm-font-sans);color:var(--pm-fg-1);letter-spacing:-.1px}
.pmempty--lg .pmempty-title{font-size:18px}
.pmempty-desc{font:400 13.5px/1.55 var(--pm-font-sans);color:var(--pm-fg-2);max-width:360px;text-wrap:pretty}
.pmempty--start .pmempty-desc{margin-left:0;margin-right:0}
.pmempty-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:16px}
.pmempty--center .pmempty-actions{justify-content:center}
.pmempty-extra{margin-top:14px;width:100%}
`;

function pmemptyEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmempty-css")) return;
  const s = document.createElement("style"); s.id = "pmempty-css"; s.textContent = PMEMPTY_CSS;
  document.head.appendChild(s);
}

export function PMEmptyState({
  icon = null,
  title,
  description,
  action = null,
  secondaryAction = null,
  size = "md",
  align = "center",
  tone = "neutral",
  children = null,
  className = "",
  style = {},
}: any) {
  pmemptyEnsureCSS();
  const cls =
    "pmempty pmempty--" + size +
    " pmempty--" + (align === "start" ? "start" : "center") +
    (tone === "brand" ? " pmempty--brand" : "") +
    (className ? " " + className : "");
  return (
    <div className={cls} style={style}>
      {icon ? <div className="pmempty-ico" aria-hidden="true">{icon}</div> : null}
      {title ? <div className="pmempty-title">{title}</div> : null}
      {description ? <div className="pmempty-desc">{description}</div> : null}
      {children ? <div className="pmempty-extra">{children}</div> : null}
      {(action || secondaryAction) ? (
        <div className="pmempty-actions">
          {action}
          {secondaryAction}
        </div>
      ) : null}
    </div>
  );
}
